export default V => [
  {
    name: 'import-csvs.list',
    path: '/import-csvs',
    component: V('importCsvs/List'),
    meta: {
      title: 'Importações em CSV',
      breadcrumb: [{ title: 'Importações em CSV' }],
    },
  },
  {
    name: 'import-csvs.show',
    path: '/import-csvs/:id',
    component: V('importCsvs/Show'),
    meta: {
      title: 'Importação em CSV',
      breadcrumb: [
        { title: 'Importações em CSV', name: 'import-csvs.list' },
        { title: 'Importação em CSV' },
      ],
    },
  },
]
